'use client'

import { useEffect, useState } from 'react'
import { Dialog } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

type Props = {
  show: boolean
  onSubmit: () => void
}

const UnknownErrorModal = ({ show, onSubmit }: Props) => {
  const translate = useTranslate()

  const [isVisible, setIsVisible] = useState(show)

  useEffect(() => {
    setIsVisible(show)
  }, [show])

  function handleRetry() {
    onSubmit()
    setIsVisible(false)
  }

  function handleClose() {
    setIsVisible(false)
  }

  return (
    <Dialog
      show={isVisible}
      title={translate('errors.modal.title')}
      body={translate('errors.modal.body')}
      actions={[
        {
          text: translate('actions.retry'),
          callback: handleRetry,
          style: Dialog.ActionStyling.Filled,
        },
        {
          text: translate('actions.close'),
          callback: handleClose,
          style: Dialog.ActionStyling.Flat,
        },
      ]}
    />
  )
}

export default UnknownErrorModal
